<template>
  <div class="sample-survey-right" @click.stop>
    <template v-if="isEmpty">
      <div class="text-center text-theme-black-450" style="padding-top: 200px">
        <span style="font-size: 40px">
          <i class="icon-bianji1"></i>
        </span>
        <div class="leading-22 mt-4 text-medium">
          <span>没有选定的题目</span>
          <br />
          <span>请添加或者选择一个题目</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="px-4 py-5">
        <div>
          <span class="text-large">Q{{ selectQuestion.num }}.题目设置</span>
        </div>
        <div class="mt-3">
          <div>
            <span class="font-bold text-medium">整体设置</span>
          </div>
          <div class="flex justify-between mt-2">
            <span class="setting-label">此题必答</span>
            <el-switch v-model="selectQuestion.is_required" @change="onUpdate" />
          </div>
          <div class="flex justify-between mt-2">
            <span class="setting-label"
              >题目隐藏
              <el-tooltip content="开启后，该题目仅发布人可见，答题者将看不到此题目">
                <span class="text-icon-default">
                  <i class="icon-shuoming"></i>
                </span>
              </el-tooltip>
            </span>
            <el-switch v-model="selectQuestion.setting.hidden" @change="onUpdate" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { update } from '@/question/operate'

const updateFactory = question => {
  return function () {
    update(question)
  }
}

export default {
  name: 'SampleSurveyRight',
  computed: {
    isEmpty() {
      return !this.selectQuestion
    },
    ...mapGetters(['selectQuestion'])
  },
  methods: {
    onUpdate() {
      this.updateHandler()
    }
  },
  created() {
    this.updateHandler = updateFactory(this.selectQuestion)
  },
  beforeDestroy() {
    this.updateHandler = null
  },
  watch: {
    selectQuestion(val) {
      if (val) {
        this.updateHandler = updateFactory(this.selectQuestion)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sample-survey-right {
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  @apply bg-white border-r border-solid border-theme-text-gray border-opacity-10;

  .setting-label {
    line-height: 22px;
    color: rgba(0, 0, 0, 0.65);
    @apply text-small;
  }
}
</style>
